import React from 'react'
export default function MinimalLeftIcon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24">{children}
<g fill={fill} stroke={stroke} className="nc-icon-wrapper"><path d="M17 23.414 6.293 12.707a.999.999 0 0 1 0-1.414L17 .586 18.414 2l-10 10 10 10L17 23.414z"/></g></svg>)
}
